import classNames from 'classnames';
import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { UiTypographyProps } from '@/components/ui/Typography/types';

import './Subtitle.scss';

interface Props {
  className?: string;
  color?: UiTypographyProps['color'];
  children: NonNullable<React.ReactNode>;
  TEST_ID?: string;
}

export const OnboardingSubtitle: React.FC<Props> = ({
  children,
  color = 'neutral-black',
  className,
  TEST_ID,
}) => {
  return (
    <UiTypography
      className={classNames('onboarding-subtitle', className)}
      data-testid={TEST_ID || 'subtitle'}
      variant="body-large"
      color={color}
      component="h4"
    >
      {children}
    </UiTypography>
  );
};
